import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { UcPartNoRequest, UcPartNoResponse } from '../models/uc-inq-by-part-no.model';

@Injectable({
  providedIn: 'root',
})
export class UcInqByPartNoService {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * 查詢 UC Part No 資料
   * POST /api/v1/item360/uc-partno/queryUcPartNo
   */
  queryUcPartNo(request: UcPartNoRequest): Observable<UcPartNoResponse> {
    const endpoint = `${environment.apiEndpoint}/uc-partno/queryUcPartNo`;
    return this.httpClient.post<UcPartNoResponse>(endpoint, request);
  }
}
